"use strict"; /// <reference lib="DOM" />

Object.defineProperty(exports, "__esModule", {
  value: true
});

var __1 = require("../..");

var fromFile = function fromFile(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onload = function () {
      var chars = new Uint8Array(reader.result);
      var contents = "";
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = chars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _char = _step.value;
          contents += String.fromCharCode(_char);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      resolve(new __1["default"](contents));
    };

    reader.onerror = function () {
      return reject(reader.error);
    };

    reader.readAsArrayBuffer(file);
  });
};

exports["default"] = fromFile;